import { render, StrictMode } from "@wordpress/element";
import { ListingObject } from "../immo/ListingObject";

export const SwtImmoListingObject = {
  connectedCallback(elm: HTMLElement) {
    const item = JSON.parse(elm.getAttribute("data-item"));

    render(
      <StrictMode>
        <ListingObject item={item}></ListingObject>
      </StrictMode>,
      elm
    );
  }
}
